import React from "react";

const AwardsOne = () => {
	// Awards data is not currently available in Strapi.
	// Hiding or showing static placeholder.
	return (
		<section className="awards sticky primary-bg">
			<div className="container">
				<div className="row justify-content-between">
					<div className="col-12 col-lg-3">
						<div className="intro">
							<h3 className="title">Awards</h3>
						</div>
					</div>
					<div className="col-12 col-lg-8">
						<ul className="list-group list-group-flush">
							<li className="list-group-item">
								<div className="content">No awards data available.</div>
							</li>
						</ul>
					</div>
				</div>
			</div>
		</section>
	);
};

export default AwardsOne;

